import {
  deserializeConfigData,
  type FullBoardConfigData,
  type CommunityPreviewDeviceMeta,
} from "@eweadn-qiankun/shared-types";
import { parseCommunityConfigPayload } from "./parseCommunityConfigPayload";
import {
  communityPreviewMetaFromCatalogRow,
  communityPreviewMetaFromPayloadFallback,
  readDeviceCatalogSnapshotFromPayload,
  resolveCatalogRowFromSnapshot,
} from "./deviceCatalogSnapshot";

export type CommunityPreviewResolveHints = {
  configPayload?: Record<string, unknown> | null;
};

/**
 * 社区预览设备元数据：优先用 configPayload._deviceCatalog 在 supportedDevices 配置表定位唯一型号；
 * displayname 仅作展示，不参与消歧。
 */
export function resolveCommunityPreviewDeviceMeta(
  deviceModel: string,
  deviceCategory: "keyboard" | "mouse",
  hints?: CommunityPreviewResolveHints
): CommunityPreviewDeviceMeta {
  const displayname = deviceModel.trim();
  const payload = hints?.configPayload ?? null;
  const snapshot = readDeviceCatalogSnapshotFromPayload(payload);
  const catalogRow = resolveCatalogRowFromSnapshot(snapshot, deviceCategory);

  if (catalogRow) {
    return communityPreviewMetaFromCatalogRow(
      displayname,
      catalogRow,
      snapshot
    );
  }

  return communityPreviewMetaFromPayloadFallback(displayname, payload);
}

export function parseCommunityBoardConfig(
  payload: Record<string, unknown> | undefined | null
): FullBoardConfigData {
  return deserializeConfigData(parseCommunityConfigPayload(payload));
}

export function parseCommunityMouseConfig(
  payload: Record<string, unknown> | undefined | null
): Record<string, unknown> {
  if (!payload || typeof payload !== "object") return {};
  return payload;
}
